import { SHOW_MESSAGE } from '../actions/show-message';
import { HIDE_MESSAGE } from '../actions/hide-message';

const initialState = {};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SHOW_MESSAGE:
      return action.payload;
    case HIDE_MESSAGE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/message.js